import { render, staticRenderFns } from "./DefferedReasonEditor.vue?vue&type=template&id=2b5dfc5c&"
import script from "./DefferedReasonEditor.vue?vue&type=script&lang=js&"
export * from "./DefferedReasonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports